import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

   emailjs.send(
  'service_hb6yu4f',
  'template_ghfegvm',
  {
    name: formData.name,
    email: formData.email,
    message: formData.message,
    title: 'Contact Inquiry' // optional, if you want to populate {{title}}
  },
  'O0_qgjMk5NP0373Gx'
).then((result) => {
      alert('Message sent successfully!');
      setFormData({ name: '', email: '', message: '' });
    }, (error) => {
      alert('Failed to send message, please try again.');
      console.log(error.text);
    });
  };

  return (
    <section id="contact">
      <div className="section-header animate-fade-in-up">
        <span className="section-number">06.</span>
        <h2 className="section-title">Get In Touch</h2>
        <div className="section-line"></div>
      </div>
      <div className="contact-content">
        <p className="contact-title animate-fade-in-up delay-2">What's Next?</p>
        <p className="contact-text animate-fade-in-up delay-3">I'm currently looking for new opportunities in software engineering and AI/ML. Whether you have a question or just want to say hi, I'll do my best to get back to you!</p>
      </div>
      <div className="contact-cta animate-fade-in-up delay-4">
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
            className="animate-fade-in-up delay-4"
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email Address"
            value={formData.email}
            onChange={handleChange}
            required
            className="animate-fade-in-up delay-4"
          />
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            required
            className="animate-fade-in-up delay-5"
          />
          <button type="submit" className="animate-fade-in-up delay-5">Send Message</button>
        </form>
      </div>
    </section>
  );
};

export default Contact;